//export const whitelabel_id = "c24f7b7f-b91c3a84-8edeeb5a-a8f6306c-2df29dc6-8ff85c3c-63a35393-b6a08945"
//export const recaptchaSiteKey = "6LfeZGMpAAAAAGr0a3cLVXQPV0TTcAEXwXnwCDCl"
//export const recaptchaSecretKey = "6LfeZGMpAAAAAO1u4TJ89KwnwTDoxJIP9wWoapbT"
//export const whitelabel_id = "9b7a9e52-5b13eb6e-107a5683-1a4c73a8-d0238ee7-bb0a6746-33a08089-a6b0f363"
//export const recaptchaSiteKey = "6LdBOmkpAAAAAMmLiSje3s6OT7NPOdP6oQ-vmLeK"
export const whitelabel_id = "effd5b07-2b6fed4a-f8238b4e-e2a0ea2e-cdb38245-867ddd7b-7bd5b159-9a57d6a2"
export const recaptchaSiteKey = "6LdT7GopAAAAAA983kWzN9-OmE7Cez6t1NU7NFUn"


